import * as ng from 'angular';

const templateUrl = require('./infinite-input.directive.html');

export class InfiniteInputController implements ng.IController {
   ngModel:ng.INgModelController;
   isInfinite:boolean;

   $onInit() {
      this.ngModel.$formatters.push(value => this.setIsInfinite(value));
   }

   get value():any {
      return this.ngModel.$viewValue;
   }

   set value(val:any) {
      this.ngModel.$setViewValue(val);
      this.setIsInfinite(val);
   }

   toggle() {
      if (this.isInfinite) {
         this.value = '0';
      } else {
         this.value = null;
      }
   }

   setIsInfinite(value) {
      this.isInfinite = value == null || ng.isUndefined(value);
      return value;
   }
}

ng.module('e360').component('infiniteInput', {
   templateUrl: templateUrl,
   require: { ngModel: 'ngModel' },
   controller: InfiniteInputController
});
